import { render, staticRenderFns } from "./predefine.vue?vue&type=template&id=06e03093&"
import script from "./predefine.vue?vue&type=script&lang=js&"
export * from "./predefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e03093')) {
      api.createRecord('06e03093', component.options)
    } else {
      api.reload('06e03093', component.options)
    }
    module.hot.accept("./predefine.vue?vue&type=template&id=06e03093&", function () {
      api.rerender('06e03093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/color-picker/src/components/predefine.vue"
export default component.exports